<template>
  <v-data-table fixed-header disable-pagination hide-default-footer :headers="headers" :items="items" no-data-text="Sem dados">
    <template v-slot:item="{ item }">
      <tr>
        <td class="custom-label">{{ item.label }}</td>
        <td v-for="indicator in item.values" :key="indicator.label">
          <div class="custom-td">
            <p class="first-value">
              {{ getIndicatorValue(indicator.referenceValue, notLocaleKeys.includes(indicator.value) ? 0 : 2, indicator.key, indicator.value) }}
            </p>
            <mf-icon icon="trending_flat" size="32" color="cinza-l60" :wght="100" />
            <p class="second-value">
              {{ getIndicatorValue(indicator.currentValue, notLocaleKeys.includes(indicator.value) ? 0 : 2, indicator.key, indicator.value) }}
            </p>
            <mf-stonks v-if="indicator.value !== 'recency'" variant="percentage" :percentage="indicator.variation" :show-icon="false" />
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import MfStonks from '@/modules/maria/produtos-impulsionadores/views/components/Step1/MfStonks.vue'
import { rfvIndicatorsEvolution } from '../../../mixins/rfv-indicators-evolution'
import { rfvAnalysis } from '../../../mixins/analise-rfv'
export default {
  name: 'RfvTable',
  components: { MfStonks },
  mixins: [rfvIndicatorsEvolution, rfvAnalysis],
  props: {
    variant: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    headers() {
      if (this.variant === 0) {
        return [
          {
            text: 'Segmento',
            value: 'segment',
            width: '120px',
            sortable: false,
          },
          {
            text: 'Consumidores',
            value: 'clients',
            width: '280px',
            sortable: false,
          },
          {
            text: 'Faturamento',
            value: 'revenue',
            width: '370px',
            sortable: false,
          },
        ]
      } else if (this.variant === 1) {
        return [
          {
            text: 'Segmento',
            value: 'segment',
            width: '120px',
            sortable: false,
          },
          {
            text: 'Gasto médio mensal',
            value: 'monthlyAverageRevenuePerClient',
            width: '370px',
            sortable: false,
          },
          {
            text: 'Ticket médio',
            value: 'averageTicket',
            width: '280px',
            sortable: false,
          },
        ]
      }

      return [
        {
          text: 'Segmento',
          value: 'segment',
          width: '120px',
          sortable: false,
        },
        {
          text: 'Cupons fiscais',
          value: 'coupons',
          width: '280px',
          sortable: false,
        },
        {
          text: 'Recência',
          value: 'recency',
          width: '200px',
          sortable: false,
        },
        {
          text: 'Frequência',
          value: 'frequency',
          width: '200px',
          sortable: false,
        },
      ]
    },
    items() {
      if (this.variant === 0) {
        return [
          {
            label: 'Campeões',
            values: [this.getFormattedValue('champions', 'clients'), this.getFormattedValue('champions', 'revenue')],
          },
          {
            label: 'Clientes leais',
            values: [this.getFormattedValue('loyals', 'clients'), this.getFormattedValue('loyals', 'revenue')],
          },
          {
            label: 'Promissores',
            values: [this.getFormattedValue('promising', 'clients'), this.getFormattedValue('promising', 'revenue')],
          },
          {
            label: 'Em risco',
            values: [this.getFormattedValue('atRisk', 'clients'), this.getFormattedValue('atRisk', 'revenue')],
          },
          {
            label: 'Baixo valor',
            values: [this.getFormattedValue('lowValue', 'clients'), this.getFormattedValue('lowValue', 'revenue')],
          },
        ]
      } else if (this.variant === 1) {
        return [
          {
            label: 'Campeões',
            values: [this.getFormattedValue('champions', 'monthlyAverageRevenuePerClient'), this.getFormattedValue('champions', 'averageTicket')],
          },
          {
            label: 'Clientes leais',
            values: [this.getFormattedValue('loyals', 'monthlyAverageRevenuePerClient'), this.getFormattedValue('loyals', 'averageTicket')],
          },
          {
            label: 'Promissores',
            values: [this.getFormattedValue('promising', 'monthlyAverageRevenuePerClient'), this.getFormattedValue('promising', 'averageTicket')],
          },
          {
            label: 'Em risco',
            values: [this.getFormattedValue('atRisk', 'monthlyAverageRevenuePerClient'), this.getFormattedValue('atRisk', 'averageTicket')],
          },
          {
            label: 'Baixo valor',
            values: [this.getFormattedValue('lowValue', 'monthlyAverageRevenuePerClient'), this.getFormattedValue('lowValue', 'averageTicket')],
          },
        ]
      }

      return [
        {
          label: 'Campeões',
          values: [
            this.getFormattedValue('champions', 'tickets'),
            this.getFormattedValue('champions', 'recency'),
            this.getFormattedValue('champions', 'frequency'),
          ],
        },
        {
          label: 'Clientes leais',
          values: [this.getFormattedValue('loyals', 'tickets'), this.getFormattedValue('loyals', 'recency'), this.getFormattedValue('loyals', 'frequency')],
        },
        {
          label: 'Promissores',
          values: [
            this.getFormattedValue('promising', 'tickets'),
            this.getFormattedValue('promising', 'recency'),
            this.getFormattedValue('promising', 'frequency'),
          ],
        },
        {
          label: 'Em risco',
          values: [this.getFormattedValue('atRisk', 'tickets'), this.getFormattedValue('atRisk', 'recency'), this.getFormattedValue('atRisk', 'frequency')],
        },
        {
          label: 'Baixo valor',
          values: [
            this.getFormattedValue('lowValue', 'tickets'),
            this.getFormattedValue('lowValue', 'recency'),
            this.getFormattedValue('lowValue', 'frequency'),
          ],
        },
      ]
    },
  },
  methods: {
    getFormattedValue(key, value) {
      return {
        key,
        value,
        referenceValue: this.getClientReferenceMetric(key, value),
        currentValue: this.getClientCurrentMetric(key, value),
        variation: this.getVariation(this.getClientReferenceMetric(key, value), this.getClientCurrentMetric(key, value)),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  border-left: 1px solid #eee;
}
::v-deep thead th {
  border-bottom: 1px solid #eee !important;
}

::v-deep .v-data-table-header tr,
::v-deep .v-data-table-header th {
  background: #fff !important;
  border-top: 1px solid #fff !important;
}

::v-deep tbody {
  td {
    color: $cinza-d10;
    font-size: 14px;
    line-height: 1;
    border-left: 1px solid #eee;
  }
}
::v-deep tbody {
  td:first-child {
    border-left: none;
  }
}
::v-deep th:first-child {
  border-left: none;
}

::v-deep .custom-label {
  color: $cinza-d10;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
}

::v-deep .custom-td {
  display: flex;
  align-items: center;
  gap: 8px;

  .first-value {
    color: $cinza-0;
    text-align: end !important;
  }

  .second-value {
    color: $marca-0-l30;
  }

  p,
  .value.percentage {
    font-size: 14px;
    margin-bottom: 0;
  }

  .value.percentage {
    margin-left: 8px;
  }
}
</style>
